import { render, staticRenderFns } from "./MenuItem.vue?vue&type=template&id=dcc7713c&scoped=true"
import script from "./MenuItem.vue?vue&type=script&lang=js"
export * from "./MenuItem.vue?vue&type=script&lang=js"
import "./MenuItem.vue?vue&type=style&index=0&id=dcc7713c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcc7713c",
  null
  
)

export default component.exports